import { inject } from "@angular/core";
import { Router, type CanActivateFn } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { map, take } from "rxjs/operators";

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return authService.currentUser$.pipe(
    take(1),
    map((user) => {
      if (user) {
        return true;
      }

      // Store the attempted URL for redirecting
      const currentUrl = state.url;
      router.navigate(["/login"], {
        queryParams: { returnUrl: currentUrl },
      });
      return false;
    })
  );
};
